import classNames from 'classnames';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import React, { useState, useEffect, useRef } from 'react';
import { ClientSideRender } from '@udemy/design-system-utils';
import { LocalizedHtml, useI18n } from '@udemy/i18n';
import { Duration } from '@udemy/react-date-time-components';
import styles from "./smart-bar-fixed-height.module.css";

/**
 * Props for the SmartBarTimer component
 */

const SECONDS_PER_DAY = 60 * 60 * 24;
export const SmartBarTimer = observer(props => {
  const {
    gettext,
    ninterpolate
  } = useI18n();
  const [remainingSeconds, setRemainingSeconds] = useState((Date.parse(props.endTime) - Date.now()) / 1000);
  const tickHandler = useRef(null);
  const COUNTDOWN_PERIOD_THRESHOLD = 60 * 60 * 24;
  const decrementRemainingTime = action(() => {
    if (remainingSeconds < 1 && tickHandler.current) {
      clearInterval(tickHandler.current);
    } else {
      setRemainingSeconds(remainingSeconds - 1);
    }
  });
  useEffect(() => {
    if (0 < remainingSeconds && remainingSeconds <= COUNTDOWN_PERIOD_THRESHOLD) {
      tickHandler.current = setInterval(() => {
        decrementRemainingTime();
      }, 1000);
    }
    return () => {
      if (tickHandler.current !== null) {
        clearInterval(tickHandler.current);
      }
    };
  }, [COUNTDOWN_PERIOD_THRESHOLD, decrementRemainingTime, remainingSeconds]);
  const remainingDays = Math.floor(remainingSeconds / SECONDS_PER_DAY);
  let timeRemainingContent;
  if (0 < remainingSeconds && remainingSeconds <= COUNTDOWN_PERIOD_THRESHOLD) {
    const precision = props.shouldShowSeconds ? Duration.PRECISION.SECONDS : Duration.PRECISION.MINUTES;
    const durationComponent = /*#__PURE__*/React.createElement(Duration, {
      "data-testid": "timer-countdown",
      numSeconds: remainingSeconds,
      precision: precision,
      presentationStyle: Duration.STYLE.HUMAN_COMPACT
    });
    timeRemainingContent = /*#__PURE__*/React.createElement(LocalizedHtml, {
      html: gettext('Ends in <span class="time">time</span>.'),
      interpolate: {
        time: durationComponent
      }
    });
  } else if (COUNTDOWN_PERIOD_THRESHOLD < remainingSeconds && remainingDays <= props.daysToShowTimer) {
    timeRemainingContent = /*#__PURE__*/React.createElement("span", {
      "data-testid": "timer-x-days-left"
    }, ninterpolate('%(remainingDays)s day left!', '%(remainingDays)s days left!', remainingDays, {
      remainingDays
    }));
  } else {
    return null;
  }

  // Apply inline styles if isInline prop is true
  const timerClasses = props.isInline ? styles['smart-bar-timer--inline'] : classNames('ud-heading-sm', styles['smart-bar-timer']);
  return /*#__PURE__*/React.createElement(ClientSideRender, null, /*#__PURE__*/React.createElement("span", {
    className: timerClasses,
    "data-testid": "smart-bar-timer"
  }, timeRemainingContent));
});
//# sourceMappingURL=smart-bar-timer.react-component.js.map